import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.pages.ReceivingSummaryPage`

export default defineMessages({
  receivingPageTitle: {
    id: `${scope}.receivingPageTitle`,
    defaultMessage: 'Receiving',
  },
})
